<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    title="更换配件"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="50%"
    top="5%"
    :close-on-click-modal="false"
  >
    <div class="border-style">配件列表</div>

    <el-table :data="itemList" style="margin-bottom: 10px">
      <el-table-column type="index" width="40"></el-table-column>
      <el-table-column prop="DciAccessoryModel.Name" label="配件型号名称" />
      <el-table-column prop="DciAccessoryModel.Number" label="配件型号" />
      <el-table-column prop="SN" label="配件SN" />
      <el-table-column width="60" label="更换">
        <template slot-scope="scope">
          <el-button
            type="primary"
            @click.stop="onChangeClick(scope.row)"
            title="更换"
          >
            <i class="fas fa-exchange-alt"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="border-style">配件更换日志</div>

    <el-timeline reverse style="margin-top: 10px">
      <el-timeline-item
        v-for="(activity, index) in activities"
        :key="index"
        :timestamp="
          $sys.dateFormat(activity.UpdatedAt) + ' ' + activity.Operator
        "
        >{{ activity.Content }}</el-timeline-item
      >
    </el-timeline>

    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 关 闭
      </el-button>
    </div>

    <el-dialog
      title="选择配件"
      :visible.sync="accvisible"
      append-to-body
      :close-on-click-modal="false"
      @close="accvisible = false"
      width="30%"
    >
      <el-form
        ref="accItemForm"
        label-width="120px"
        :model="accItem"
        :rules="accRules"
      >
        <el-form-item label="配件SN" prop="TaID">
          <select2
            labelName="SN"
            v-model="accItem.TaID"
            url="dci/product/stock-canuse-acc-list"
            :clearable="true"
            placeholder="选择配件SN"
            no-data-text="没有配件SN"
            style="width: 100%"
            :urlParams="{
              where: {},
            }"
            q="SN:like"
            :qinwhere="true"
            :queryOne="false"
          ></select2>
        </el-form-item>
        <el-form-item label="质保开始日期" prop="QualityStartAt">
          <el-date-picker
            v-model="accItem.QualityStartAt"
            style="width: 100%"
            type="date"
            placeholder="请选择日期"
            @change="changeDate"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="质保结束日期" prop="QualityEndAt">
          <el-date-picker
            v-model="accItem.QualityEndAt"
            style="width: 100%"
            type="date"
            placeholder="请选择日期"
          ></el-date-picker>
        </el-form-item>
        <div style="text-align: right">
          <el-button type="text" @click="syncQualityDate"
            >同步产品质保日期</el-button
          >
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="accvisible = false">
          <i class="fas fa-fw fa-times" aria-hidden="true"></i> 取 消
        </el-button>
        <el-button type="primary" @click="onChangeConfim" :disabled="changing">
          <i class="far fa-fw fa-save" aria-hidden="true"></i> 确 定
        </el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    return {
      item: _.clone(this.value), //产品
      orItem: null, //原配件
      taItem: null, //新配件
      itemList: [], //产品相关配件
      activities: [], //配件更换日志
      changing: false,
      accvisible: false,
      accItem: {
        //更换配件信息
        OrID: null,
        TaID: null,
        QualityStartAt: null,
        QualityEndAt: null,
      },
      accRules: {
        TaID: [{ required: true, message: "配件SN不能为空", trigger: "blur" }],
        QualityStartAt: [
          { required: true, message: "质保开始日期不能为空", trigger: "blur" },
        ],
        QualityEndAt: [
          { required: true, message: "质保结束日期不能为空", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    onOpen() {
      this.item = _.cloneDeep(this.value);
      this.getList();
      this.getLog();
    },
    onClose() {
      this.$emit("update:visible", false);
      this.itemList = [];
    },
    //配件更换日志
    getLog() {
      this.$axios
        .get(`dci/product/${this.item.ID}/change_record`)
        .then((response) => {
          this.activities = response.data.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    //获取产品相关配件
    getList() {
      this.$axios
        .get("dci/accessory/stock-list/list", {
          params: {
            where: {
              DciProductID: this.item.ID,
            },
            with: ["DciAccessoryModel"],
            order: ["-sn"],
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    changeDate(val) {
      //质保开始日期修改，质保结束日期也自动修改,默认质保开始日期开始一年
      if (val) {
        const date = this.accItem.QualityStartAt;
        this.accItem.QualityEndAt = new Date(
          date.getTime() + 3600 * 1000 * 24 * 365
        );
      } else {
        this.accItem.QualityEndAt = val;
      }
    },
    syncQualityDate() {
      this.accItem.QualityStartAt = this.item.QualityStartAt; //默认产品质保日期
      this.accItem.QualityEndAt = this.item.QualityEndAt;
    },
    //点击更换按钮
    onChangeClick(row) {
      this.accvisible = true;

      this.orItem = row;
      this.accItem.OrID = row.ID;
      this.accItem.TaID = null;
      this.accItem.QualityStartAt = this.item.QualityStartAt; //默认产品质保日期
      this.accItem.QualityEndAt = this.item.QualityEndAt;
    },
    onChangeConfim() {
      this.$refs.accItemForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.changing = true;
        //先判断是不是不同型号
        this.$axios
          .get(`dci/accessory/${this.accItem.TaID}`)
          .then((response) => {
            this.taItem = response.data;

            //如果不是同型号，确认是否更换
            if (
              this.orItem.DciAccessoryModel != null &&
              this.taItem.DciAccessoryModel != null &&
              this.orItem.DciAccessoryModel.Number !=
                this.taItem.DciAccessoryModel.Number
            ) {
              this.$confirm("配件型号不一致，确定继续更换此配件？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
                .then(() => {
                  this.onChange();
                })
                .catch(() => {
                  this.changing = false;
                });
            } else {
              this.onChange();
            }
          })
          .catch(({ response }) => {
            this.changing = false;
            this.$sys.alarmResponse(response);
          });
      });
    },
    onChange() {
      this.$axios
        .request({
          url: "dci/product/accessory-exchange",
          method: "post",
          data: this.accItem,
        })
        .then(() => {
          this.changing = false;
          this.accvisible = false;
          this.getList();
          this.getLog();
          this.$message.success("更换成功");
        })
        .catch(({ response }) => {
          this.changing = false;
          this.$sys.alarmResponse(response);
        });
    },
  },
};
</script>
<style scoped>
.el-timeline {
  margin: 0;
  font-size: 10px;
  list-style: none;
}
.el-card__body {
  padding: 5px;
}
.el-timeline-item__timestamp {
  color: #909399;
  line-height: 1;
  font-size: 8px;
}
.border-style {
  height: 28px;
  line-height: 28px;
  border-radius: 0 15px 15px 0;
  border-left: 3px solid #409eff;
  padding-left: 5px;
  margin-bottom: 10px;
  background-color: #ecf5ff;
  color: #409eff;
  font-size: 13px;
  font-weight: bolder;
}
</style>

